import { render, staticRenderFns } from "./GoldMallActivity.vue?vue&type=template&id=a5eef7a8&scoped=true&"
import script from "./GoldMallActivity.vue?vue&type=script&lang=js&"
export * from "./GoldMallActivity.vue?vue&type=script&lang=js&"
import style0 from "./GoldMallActivity.vue?vue&type=style&index=0&id=a5eef7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5eef7a8",
  null
  
)

export default component.exports